module.exports = __webpack_public_path__ + "static/media/kodekloud.26bcdf57.png";